import { Http, EndPoints, getParams, TypeParams, TypeResource, CompanyID, ID } from '../../core/utils';
import { ActiveReports, DownloadReportsExcel, RefreshReport, ReportActivation, ReportSummaryResponse, Suscription, SuscriptionsList, Template, UserCompaniesReports, unsuscribeReport } from '../models';
import { BackendDynamicField } from '../../../features/alarms/api/types';

export const ReportsServices = {
    //Home - Report Summary
    getSummaryByCompany: (company_id:ID): Promise<ReportSummaryResponse> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SUMMARY_COMPANY}`, {
            params: getParams([{ key: TypeParams.ID, value: company_id }]),
        }).then(response => response.data),

     //refresh report data
     refreshReport: (data: RefreshReport): Promise<any> =>
      Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.REFRESH_REPORT}`, data)
          .then(response => response.data),

    //list template
    getTemplatesList: (): Promise<Template[]> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.TEMPLATE_LIST}`).then(response => response.data),

    //list user companies reports
    getUserCompaniesReports: (template_name: string): Promise<UserCompaniesReports[]> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.TEMPLATE_COMPANY_LIST}`, {
            params: getParams([{ key: TypeParams.TEMPLATE_NAME, value: template_name }]),
        }).then(response => response.data),

    //get excels list for a report
    getExcelsList: (template_id: string, company_id: string): Promise<any> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.EXCELS_LIST}`, {
            params: getParams([
                { key: TypeParams.TEMPLATE_ID, value: template_id },
                { key: TypeParams.COMPANY_ID, value: company_id },
            ]),
        }),
    
    //load excel for report
    uploadExcelForReport: (data: any): Promise<any> =>
        Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.UPLOAD_EXCEL}`, data)
            .then(response => response.data),

    downloadExcelForReport: (fileId: string): Promise<any> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.UPLOAD_EXCEL}`, {
            params: getParams([
                { key: TypeParams.ID, value: fileId },
            ]),
            responseType: 'arraybuffer'
        })
        .then(response => response.data),

    //list active reports
    getActiveReportsByCompany: (company_id: string, allCompanies: boolean): Promise<ActiveReports[]> => {
        let url = `${TypeResource.REPORTS}${EndPoints.ReportsUrls.ACTIVE_REPORTS}`;
        if (allCompanies) {
            url += `?${TypeParams.ALL_COMPANIES}=${allCompanies.toString()}`;
        } else {
            url += `?${TypeParams.COMPANY_ID}=${company_id}`;
        }

        return Http.get(url).then(response => response.data)
    },

    //list subscription
    getSuscriptionsByCompany: (): Promise<SuscriptionsList[]> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SUSCRIPTION_LIST}`).then(response => response.data),

    activateReports(config: Array<ReportActivation>): Promise<any> {
        return Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.ACTIVATE_REPORTS}`, config)
        .then(response => response.data);
    },

    deactivateReports(config: Array<ReportActivation>): Promise<any> {
        return Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.DEACTIVATE_REPORTS}`, config)
        .then(response => response.data);
    },        

    //remove suscription
    removeSuscription: (id: number): Promise<any> =>
        Http.delete(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SUSCRIPTION}`, {
            params: getParams([{ key: TypeParams.ID, value: id }])
        }).then(response => response.data),

    //post suscription
    postSuscription: (suscription: Suscription): Promise<any> =>
        Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SUSCRIPTION}`, suscription)
            .then(response => response.data),

    //download reports to excel
    downloadExcel: (data: DownloadReportsExcel): Promise<any> =>
        Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.DOWNLOAD_EXCEL}`, data, {
            responseType: 'arraybuffer'
        }).then(response => response.data),

    deleteExcelForReport: (id: ID): Promise<any> =>
        Http.delete(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.UPLOAD_EXCEL}`, {
            params: getParams([{ key: TypeParams.ID, value: id }])
        }).then(response => response.data),

    //patch suscription
    patchSuscription: (suscription: Suscription, suscriptionId: string): Promise<any> =>
        Http.patch(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SUSCRIPTION}`, suscription, {
            params: getParams([{ key: TypeParams.ID, value: suscriptionId }])
        }).then(response => response.data),

    //CONFIGURACION DEL REPORTE
    //obtener campos dinamicos para el modal de configuracion
    getDynamicFields: (template_id: SuscriptionsList["template"]["template_id"]): Promise<BackendDynamicField> =>
        Http.get(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SETTINGS_GET_DYNAMIC_FIELDS}`, {
            params: getParams([{ key: TypeParams.TEMPLATE_ID, value: template_id }])
        }).then(response => response.data),

    //guardar configuracion del reporte
    saveReportSettings: (template_id:number, config: BackendDynamicField): Promise<any> =>
        // Http.post(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SETTINGS_SAVE}`, data).then(response => response.data),
        Http.patch(`${TypeResource.REPORTS}${EndPoints.ReportsUrls.SETTINGS_SAVE}`, config, {
            params: getParams([{ key: TypeParams.TEMPLATE_ID, value: template_id }])
        })
            .then(response => response.data),
};

const joinParams = (ids: CompanyID[] | string[], separator: string) => ids.join(separator);
